<div class="page-content-wrapper">
  <div ref="services_container">
    <div class="card rounded-3 border-1 shadow p-0">
      <div class="card-header border-0 bg-white">
        <h6 class="mb-0 fw-bold">
          Services in {{ workflow_name || 'Your Workflow' }}
        </h6>
      </div>

          <div class="card-body">
            <table id="order-service-table" class="table table-responsive w-100">
              <thead class="bg-dark text-white">
                <tr>                  
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7">Service Name</th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7">Run in Background</th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7">Order Service</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(service, index) in sorted_services" :key="service.service_id">
                  <td v-if="service.type ==='form'" class="text-xxs ">{{ service.category.category_name }}</td>
                  <td v-else class="text-xxs">{{ service.service_name }}</td>
                  <td>
                    
                    <div v-if="service.service_details && service.service_details.length > 0">
                      <div class="form-check form-switch" v-if="service.service_name == 'Address Match' || service.service_name == 'Anti Money Laundering' || service.service_name == 'Eligibility Solution' || service.service_name == 'Enterprise Credit Check' || service.service_name == 'Enterprise Anti Money Laundering' || service.service_name == 'Experian Credit Report (PDF)' || service.service_name == 'Telephones'">
                        <input class="form-check-input" type="checkbox" :checked="service.is_background" @change="update_background(service.workflow_project_service_id, $event.target.checked)"/>
                        <label class="form-check-label text-xxs">
                          <span v-if="service.is_background == true">Yes</span>
                          <span v-else>No</span>
                        </label>
                      </div>
                      <div class="form-check form-switch" v-else-if="service.service_name == 'Director Screening'">
                        <input 
                          class="form-check-input" 
                          type="checkbox"
                          checked 
                          disabled 
                        />
                        <label class="form-check-label text-xxs">
                          <span>Yes</span>
                        </label>
                      </div>
                      <div v-else>
                        <span class="text-xxs">
                          <i class="fa fa-exclamation-triangle mx-1 text-warning"></i> Unavailable
                        </span>
                      </div>
                    </div>
                    <div v-else>
                      <span class="text-xxs">
                        <i class="fa fa-info-circle mx-1 text-info"></i> Custom Service
                      </span>
                    </div>
                  </td>
                  <td>
                    <!-- Button to Open Modal -->
                    <button class="btn btn-sm bg-green rounded-small secondary-text-dark text-xxs" type="button" @click="open_modal(service)">
                      <i class="bi bi-list"></i> {{ service.selected_order ? service.selected_order : 'Select Order' }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="col-md-12">
              <div align="right" class="p-2">
                <button type="button" class="btn bg-green rounded-small text-xxs shadow secondary-text-dark" @click="route_to">Confirm Order</button>
              </div>
            </div>
          </div>
        </div>
      </div>

  <!-- Modal Structure -->
  <div v-if="selectedService" id="yourModal" class="modal fade show order-service-modal" tabindex="-1" aria-labelledby="modalTitle" aria-modal="true" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content rounded-3">
        <div class="modal-header">
          <h6 class="modal-title" id="modalTitle">Order Numbering</h6>
          <button type="button" class="btn-close" aria-label="Close" @click="close_modal"></button>
        </div>
        <div class="modal-body">
          <!-- Dropdown List for Numbers -->
          <div class="form-group">
            <label for="orderSelect" class="text-xs">Select Order</label>
            <div class="input-group">
              <select v-model="selectedOrder" id="orderSelect" class="form-select text-xs rounded-small shadow-sm">
                <option v-for="n in maxOrder" :key="n" :value="n">{{ n }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn bg-green rounded-small shadow text-xs" @click="save_order">Update</button>
        </div>
      </div>
    </div>
  </div>
</div>
